// extracted by mini-css-extract-plugin
module.exports = {"searchPage":"aaw_if","body":"aaw_g1","ctaContainer":"aaw_ig","cta":"aaw_ih"};